import { useCallback, useEffect, useRef } from 'react';

interface IReturnValue {
  checkIfMounted: () => boolean;
  runIfMounted: (cb: () => void) => void;
}
function useIsMounted(immediateCb?: () => void): IReturnValue {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    immediateCb?.();

    return () => {
      isMounted.current = false;
    };
  }, [immediateCb]);

  const runIfMounted = useCallback((cb: () => void) => {
    if (isMounted) {
      cb();
    }
  }, []);
  const checkIfMounted = useCallback(() => isMounted.current, []);
  return { checkIfMounted, runIfMounted };
}

export default useIsMounted;
